import React from 'react';
import { Typography } from 'ui';
import { Color, TypeScales } from 'ui/primitives';
import Markdown from 'markdown-to-jsx';
import ProThumb from '../../../../icons/ProThumb.svg';
import ConThumb from '../../../../icons/ConThumb.svg';
import s from './Verdict.module.scss';

export const Verdict = ({ verdictData }) => {
  const a = '';
  return (
    <div className={s.root}>
      <Typography label="Park+ Verdict" variant="h2" className={s.heading} />
      {verdictData?.description && (
        <Typography
          label={verdictData?.description}
          variant="body_para_m"
          className={s.sub_heading}
          color="text_subheading"
        />
      )}
      <div className={s.pros_cons}>
        <div className={s.pros}>
          <div className={s.heading}>
            <ProThumb />
            <Typography label="Pros" variant="h3" renderAs="H2" />
          </div>
          <div className={s.list}>
            <ul>
              <Markdown>{verdictData?.pros}</Markdown>
            </ul>
          </div>
        </div>
        <div className={s.cons}>
          <div className={s.heading}>
            <ConThumb />
            <Typography label="Cons" variant="h3" renderAs="H2" />
          </div>
          <div className={s.list}>
            <ul>
              <Markdown>{verdictData?.cons}</Markdown>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
